module.exports = __webpack_public_path__ + "753118e9eadeccf4911748feed3579b4.png";